export default __webpack_public_path__ + "static/news_bg-bf542615392b4fe46726f91809a2b025.jpg";